import React from 'react'

import { UspIcon } from '~/assets/icons'
import UspBadge from '~/components/usp-badge'
import { Promotion } from '~/gql/graphql'

import styles from './styles.module.css'

const UspMeta = ({ promotionType, title }: { promotionType: string; title: string }) => {
  if (promotionType !== 'uswitch-award') return null

  return <meta itemProp='award' content={title} />
}

const getVariant = (type: string, title: string) => {
  if (type === 'black-friday') return 'black-primary'

  if (
    (type === 'voucher' && !title.includes('mid-contract price rises')) ||
    (type === 'bill-credit' && !title.includes('save'))
  ) {
    return 'yellow-secondary'
  }

  if (type === 'next-gen-promotion') {
    return 'next-gen-green'
  }

  if (type === 'city-fibre-next-gen-promotion') {
    return 'next-gen-blue'
  }

  return 'yellow-primary'
}

export const UspItems = ({ promotionItems }: { promotionItems: Promotion[] }) => {
  if (!promotionItems.length) return null

  return (
    <ul className={`usps ${styles.itemContainer}`} data-selector='usp-items'>
      {promotionItems.map((promotion) => {
        const { id, type, title } = promotion

        if (title === 'Uswitch exclusive') return null

        return (
          <UspBadge
            className={`usps ${styles.item}`}
            key={id}
            text={title}
            icon={<UspIcon className={`usps ${styles.icon}`} promotionType={type} />}
            variant={getVariant(type, title)}
            as='li'
          >
            <UspMeta promotionType={type} title={title} />
          </UspBadge>
        )
      })}
    </ul>
  )
}
